import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / Color`}</p>
    <h1 {...{
      "id": "class-color"
    }}>{`Class: Color`}</h1>
    <p>{`Represents a color in a defined RGB colorspace. Value is immutable – to change, create a new Color object.`}</p>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`ProxyLiveObject`}</inlineCode></p>
        <p parentName="li">{`↳ `}<strong parentName="p"><inlineCode parentName="strong">{`Color`}</inlineCode></strong></p>
      </li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "accessors"
    }}>{`Accessors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#alpha"
        }}>{`alpha`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#blue"
        }}>{`blue`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#colorSpace"
        }}>{`colorSpace`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#green"
        }}>{`green`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#red"
        }}>{`red`}</a></li>
    </ul>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Color.md#getHex"
        }}>{`getHex`}</a></li>
    </ul>
    <h2 {...{
      "id": "accessors-1"
    }}>{`Accessors`}</h2>
    <h3 {...{
      "id": "a-idalpha-namealphaa-alpha"
    }}><a id="alpha" name="alpha"></a>{` alpha`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`alpha`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The alpha channel in range from 0 - 1.`}</p>
    <h4 {...{
      "id": "returns"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idblue-namebluea-blue"
    }}><a id="blue" name="blue"></a>{` blue`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`blue`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The blue channel in range from 0 - 1.`}</p>
    <h4 {...{
      "id": "returns-1"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcolorspace-namecolorspacea-colorspace"
    }}><a id="colorSpace" name="colorSpace"></a>{` colorSpace`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`colorSpace`}</strong>{`(): `}<a parentName="p" {...{
        "href": "../enums/ColorSpace.md#sRGB"
      }}><inlineCode parentName="a">{`sRGB`}</inlineCode></a></p>
    <p>{`This color's color space. Currently only sRGB is supported.`}</p>
    <h4 {...{
      "id": "returns-2"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "../enums/ColorSpace.md#sRGB"
      }}><inlineCode parentName="a">{`sRGB`}</inlineCode></a></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idgreen-namegreena-green"
    }}><a id="green" name="green"></a>{` green`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`green`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The green channel in range from 0 - 1.`}</p>
    <h4 {...{
      "id": "returns-3"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idred-namereda-red"
    }}><a id="red" name="red"></a>{` red`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`red`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The red channel in range from 0 - 1.`}</p>
    <h4 {...{
      "id": "returns-4"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h2 {...{
      "id": "methods-1"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "a-idgethex-namegethexa-gethex"
    }}><a id="getHex" name="getHex"></a>{` getHex`}</h3>
    <p>{`▸ `}<strong parentName="p">{`getHex`}</strong>{`(): `}<inlineCode parentName="p">{`string`}</inlineCode></p>
    <p>{`Get the color in 8-digit hex "#RRGGBBAA" format.`}</p>
    <h4 {...{
      "id": "returns-5"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`string`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      